'use client';

import { ClockSubscriber } from '@velocity-exchange/sdk';
import { useEffect } from 'react';
import useVelocityStore from '../stores/VelocityStore/useVelocityStore';
import { VelocityWindow } from '../window/velocityWindow';
import Env from 'src/environmentVariables/EnvironmentVariables';

const useSyncVelocityClock = () => {
	const connection = useVelocityStore((s) => s.connection.current);

	useEffect(() => {
		if (!connection) return;

		const clockSubscriber = new ClockSubscriber(connection, {
			commitment: Env.defaultCommitmentLevel,
		});

		clockSubscriber.subscribe();

		const interval = setInterval(() => {
			VelocityWindow.chainClock.update({
				commitment: clockSubscriber.commitment,
				slot: clockSubscriber.latestSlot,
				ts: clockSubscriber.currentTs,
			});
		}, 1000);

		return () => {
			clearInterval(interval);
			clockSubscriber.unsubscribe();
		};
	}, [connection]);
};

export default useSyncVelocityClock;
